export default __webpack_public_path__ + "static/media/supper_apps_s2.b19a90c7.png";